import { all, call, takeEvery, put, delay } from "redux-saga/effects";
import customerActions from "./actions";
import axios from "axios";
import { API_URL } from "../../utils/constants";
import Cookies from "js-cookie";
import capVerifierActions from "./actions";
import commonActions from "../common/actions";

const capVerifierSagas = function* () {
  yield all([
    // yield takeEvery(capVerifierActions.GET_CAP_COURSE_DOCUMENT, getCapCourseDocument),
    yield takeEvery(capVerifierActions.CREATE_CAP_VERIFIER, createCapVerifier),
    yield takeEvery(capVerifierActions.UPDATE_CAP_VERIFIER, updateCapVerifier),
    yield takeEvery(capVerifierActions.GET_CAP_VERIFIER_BY_ID, getCapVerifierById),
    // yield takeEvery(capVerifierActions.SET_ACTIVE_CAP_COURSE_DOC, setActiveCapCourse),
  ]);
};


const createCapVerifier = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
console.log('payload---',payload);

  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/backoffice/cap-verifier/add-capverifier`, {
        payload:payload?.data, // optional, if applicable
      })
    );

    if (result?.data?.statusCode === 200) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      // yield put({
      //   type: capVerifierActions.GET_CAP_VERIFIER_BY_ID,
      // });

      // payload?.navigate(
      //   `/${Cookies.get("mhet_mst_project")}/cap-verifier-master?page=verifier-list`
      // );
      // payload?.reset()
      // payload?.resetForm()
    }

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });

    yield delay(2000);
    



    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });


    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });

  } catch (err) {
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: "failed",
        show: true,
        message: "Failed to create CAP Verifier.",
      },
    });
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });

};

const updateCapVerifier = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    const result = yield call(() =>
      axios.put(
        `${API_URL}/backoffice/cap-verifier/update-capverifier/${payload?.data?.capverifierid}`,
        payload?.data
      )
    );

    if (result?.data?.statusCode === 200) {
      yield put({
        type: capVerifierActions.GET_CAP_VERIFIER_LIST,
      });

      payload?.navigate(
        `/${Cookies.get("mhet_mst_project")}/cap-verifier-master?page=verifier-list`
      );
    }

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });

    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });

  } catch (err) {
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: "failed",
        show: true,
        message: "Failed to update CAP Verifier.",
      },
    });
  }

  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getCapVerifierById = function* (data) {
  const { payload } = data; // payload should contain capverifierid
  const { capverifierid, navigate } = payload;

  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/cap-verifier/getcapverifier/${payload}`)
    );

    if (result?.data?.statusCode == 200) {
      yield put({
        type: capVerifierActions.SET_CAP_VERIFIER,
        payload: result.data.data, // assuming data contains verifier details
      });

      // if (navigate) {
      //   navigate(`/${Cookies.get("mhet_mst_project")}/cap-verifier-master?page=verifier-detail&id=${capverifierid}`);
      // }
    
    
    }

    // yield put({
    //   type: commonActions.SET_ALERT,
    //   payload: {
    //     status: result?.data?.statusCode === 200 ? "success" : "failed",
    //     show: true,
    //     message: result?.data?.message || (result?.data?.statusCode !== 200 ? "Failed to fetch verifier" : ""),
    //   },
    // });

    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });

    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });

  } catch (err) {
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: "failed",
        show: true,
        message: "Failed to fetch CAP Verifier by ID.",
      },
    });
  }

  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

export default capVerifierSagas;